import { FormattedMessage } from "react-intl";
import folderAddIcon from "../../../../../assets/management/folder_add.svg";
import removeIcon from "../../../../../assets/shared/remove.svg";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import { Button } from "@shltelemedicine/shl-ui-lib";
import EditButton from "../../../../Shared/EditButton/EditButton";
import styles from "./EntityActions.module.css";
import { useAuthContext } from "../../../../../context/AuthContext";
import { useEffect, useState } from "react";
import { Permissions } from "../../../../../models/permission";
import authorizationService from "../../../../../services/authorization.service";

type EntityActionsProps = {
  hideDelete?: boolean;
  hideAdd?: boolean;
  hideEdit?: boolean;
  onAddEntity?: () => void;
  onDeleteEntity?: () => void;
  onEditEntity?: () => void;
};

const EntityActions = ({
  hideDelete,
  hideAdd,
  hideEdit,
  onAddEntity,
  onDeleteEntity,
  onEditEntity,
}: EntityActionsProps) => {
  const {
    state: { user },
  } = useAuthContext();

  const [canManageEntities, setCanManageEntities] = useState(false);

  useEffect(() => {
    if (!user) return;
    setCanManageEntities(
      authorizationService.hasPermissions(user.permissions, [
        Permissions.CanManageEntities,
      ])
    );
  }, [user]);

  const addEntityHandler = () => {
    if (onAddEntity) onAddEntity();
  };

  const deleteEntityHandler = () => {
    if (onDeleteEntity) onDeleteEntity();
  };

  const editEntityHandler = () => {
    if (onEditEntity) onEditEntity();
  };

  return canManageEntities ? (
    <div className="d-flex align-items-center">
      <div>
        <Button
          variant=""
          className={styles.button}
          icon={{ src: folderAddIcon, width: 18, height: 18 }}
          disabled={hideAdd}
          style={{ visibility: hideAdd ? "hidden" : "visible" }}
          onClick={addEntityHandler}
        >
          <FormattedMessage
            id="MANAGEMENT.ADD_ENTITY"
            defaultMessage="Add Entity"
          />
        </Button>
      </div>
      <EditButton
        style={{ visibility: hideEdit ? "hidden" : "visible" }}
        onClick={editEntityHandler}
        className="mx-2"
      />
      <Button
        className={styles.button}
        style={{ visibility: hideDelete ? "hidden" : "visible" }}
        onClick={deleteEntityHandler}
      >
        <BaseIcon icon={removeIcon} className={styles.icon} />
      </Button>
    </div>
  ) : (
    <></>
  );
};

export default EntityActions;
